import Vue from 'vue';
import axios from 'axios';
import { stateMerge } from 'vue-object-merge';
import { is } from 'core-js/core/object';

const code = process.env.VUE_APP_APICODE;
const apiUrl = process.env.VUE_APP_APIADDRESS;
export default {
    namespaced: true,
    state: {
        title: '',
        forenames: '',
        surname: '',
        dob: '',
        sex: '',
        maritalStatus: '',
        phoneNumbers: {
            Home: '',
            Work: '',
            Mobile: '',
        },
        address: {
            line1: '',
            line2: '',
            line3: '',
            line4: '',
        },
        isRegistered: false,
        email: 'name.surname@lcp.uk.com',
        userId: '',
        latestUnconfirmedAddress: {},
        latestConfirmedAddress: {},
        webforms: [],
    },
    getters: {
        userDetails: s => s,
        isRegistered: s => s.isRegistered,
        webforms: s => s.webforms,
        webformsSortedByCreation: s => s.webforms.sort((a, b) => new Date(b.creationTime) - new Date(a.creationTime)),
        webformsSortedByCreationFilteringOutAdmin: s => s.webforms.filter((w) => {
            const cutOffDateForAdmin = new Date('2023-07-10');
            const dateFormCreated = new Date(w.creationTime);
            const isGeneratedByAdmin = w.isGeneratedByMember === false;
            const formCreatedAfterCutOffDate = dateFormCreated >= cutOffDateForAdmin;
            return !isGeneratedByAdmin || (isGeneratedByAdmin && !formCreatedAfterCutOffDate);
        }),
    },
    mutations: {
        updateUserData (state, payload) {
            stateMerge(state, payload);
        },
        // updateAddressDetails (state, payload) {
        //     // stateMerge(state, payload, 'latestUnconfirmedAddress', false);
        //     Vue.set(state, 'latestUnconfirmedAddress', payload);
        // },
        updatePhoneNumbers (state, payload) {
            Vue.set(state, 'phoneNumbers', payload);
        },
        setRegisteredStatus (state, payload) {
            Vue.set(state, 'isRegistered', payload);
        },
        addWebform (state, webId) {
            state.webforms.push(webId);
        },
        setWebforms (state, webforms) {
            Vue.set(state, 'webforms', webforms);
        },
    },
    actions: {
        updateAddressApi ({ commit }, payload) {
            return axios
                .post(`${apiUrl}/ChangeAddress?code=${code}`, payload)
                .then((response) => {
                    if (response.data.success) {
                        // all ok now update the state to reflect the changes
                        commit('updateAddressDetails', payload.Address, { root: true });
                    }
                    return response.data;
                });
        },
        updateTelephoneApi ({ commit }, payload) {
            return axios
                .post(`${apiUrl}/UpdatePhoneNumbers?code=${code}`, payload)
                .then((response) => {
                    if (response.data.success) {
                        // all ok now update the state to reflect the changes
                        commit('updatePhoneNumbers', payload);
                    }
                    return response.data;
                });
        },
        notificationOfDeathApi ({ commit }, payload) {
            return axios
                .post(`${apiUrl}/NotificationOfDeath?code=${code}`, payload)
                .then((response) => {
                    if (response.data.success) {
                        // all ok now update the state to reflect the changes
                        commit('notificationOfDeath', payload);
                    }
                    return response.data;
                });
        },
        registerUser ({ commit }, payload) {
            return axios
                .post(`${apiUrl}/Activate?code=${code}`, payload)
                .then((response) => {
                    if (response.data.success) {
                        // all ok now update the state to reflect the changes
                        commit('setRegisteredStatus', true);
                    }
                    return response.data;
                });
        },
        isRegistered ({ commit }, payload) {
            return axios
                .get(`${apiUrl}/IsRegistered?code=${code}`, payload)
                .then((response) => {
                    if (response.data.success) {
                        // all ok now update the state to reflect the changes
                        commit('setRegisteredStatus', true);
                    }
                    return response.data;
                });
        },
        generateWebForm (context, payload) {
            return axios
                .post(`${apiUrl}/GenerateWebForm?code=${code}`, payload)
                .then(response => response.data);
        },
        getWebForms ({ commit }) {
            return axios.get(`${apiUrl}/GetWebForms?code=${code}`).then((response) => {
                commit('setWebforms', response.data);
                return response.data;
            });
        },
        UpdateMaritalStatusDependantInfo (context, payload) {
            return axios
                .post(`${apiUrl}/UpdateMaritalStatusDependantInfo`, payload)
                .then(response => response.data);
        },
    },
};
